import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MbscCalendarEvent, MbscDateType, MbscEventcalendarView, MbscEventClickEvent, MbscModule, MbscPopup, MbscPopupOptions } from '@mobiscroll/angular';
import { ThemeService } from '../../../services/shared/theme.service';
import { AuthService } from '../../../services/auth/service/auth.service';
import { ScreenService } from '../../../services/shared/screen.service';
import { GetTraveltimeService } from '../../../services/fetchServices/fetchTraveltime/POST/get-traveltime.service';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { FilterEventPopupComponent } from "../popups/filter-event-popup/filter-event-popup.component";
import { GETEventService } from '../../../services/fetchServices/fetchEvent/GET/get-event.service';
import { MoveToEventService } from '../../../services/shared/move-to-event/move-to-event.service';
import { InputGroupComponent, ProgressComponent, DropdownToggleDirective, DropdownMenuDirective, DropdownComponent ,ButtonDirective , BadgeComponent, DropdownHeaderDirective, HeaderNavComponent} from '@coreui/angular-pro';
import { freeSet } from '@coreui/icons';
import { IconDirective } from '@coreui/icons-angular';
import { FetchUserService } from '../../../services/fetchServices/fetchUser/fetch-user.service';
import { filter, firstValueFrom, Subject, takeUntil } from 'rxjs';
import { EventViewSearchComponent } from "../event-view-search/event-view-search.component";
import { PlaceholderService } from '../../../services/shared/placeholder.service';
import { MenuSidebarComponent } from './menu-sidebar/menu-sidebar.component';
import { WebSocketService } from '../../../services/web-socket.service';
import { DateChangeService } from '../../../services/shared/date-change.service';
import { EventViewNotificationsComponent } from "./event-view-notifications/event-view-notifications/event-view-notifications.component";
import { SvgIconService } from '../../../services/shared/icons/svg-icon.service';
import { datetime } from '@mobiscroll/angular/dist/js/core/util/datetime.js';

@Component({
  selector: 'app-header',
  imports: [
    MbscModule,
    CommonModule,
    FormsModule,
    FilterEventPopupComponent,
    InputGroupComponent,
    IconDirective,
    EventViewSearchComponent,
    MenuSidebarComponent,
    ProgressComponent,
    DropdownComponent,
    ButtonDirective,
    DropdownToggleDirective,
    DropdownMenuDirective,
    BadgeComponent,
    DropdownHeaderDirective,
    HeaderNavComponent,
    EventViewNotificationsComponent
],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  
})
export class HeaderComponent {
  constructor(
    public themeService: ThemeService,
    private authService: AuthService,
    public screenService: ScreenService,
    public traveltimeService: GetTraveltimeService,
    private router: Router,
    private route: ActivatedRoute,
    private getEventService: GETEventService,
    private calendarEventService: MoveToEventService,
    private fetchUserService: FetchUserService,
    private placeholderService: PlaceholderService,
    private socketService: WebSocketService,
    private dateChangeService: DateChangeService,
    public svgIconService: SvgIconService,
    private cdr: ChangeDetectorRef
  ) {}

  icons = freeSet;

  @ViewChild(FilterEventPopupComponent) eventFilterPopup!: FilterEventPopupComponent;
  @ViewChild('eventFilterButton') templateFilterButton!: ElementRef;
  @ViewChild('eventFilterButton') eventAnchorElm!: ElementRef;

  @Output() eventClicked = new EventEmitter<any>();
  @Output() toggleOverlay = new EventEmitter<boolean>();
  @Output() setLoading = new EventEmitter<boolean>();
  @Output() eventFilterError = new EventEmitter<any>();
  @Output() resetFilterError = new EventEmitter<any>();

  errorFilterActive: boolean = false;
  filterName: string = '';

  @Input() selectedDateInput!: MbscDateType;

  UserPermission: any
  UserRole: any 
  popupAnchor: HTMLElement | undefined;
  listEvents: MbscCalendarEvent[] = [];
  originalEvents: MbscCalendarEvent[] = [];
  displayResults = false;
  timer?: ReturnType<typeof setTimeout>;
  selectedDate: MbscDateType = new Date();
  listView: MbscEventcalendarView = { agenda: { type: 'year', size: 5 } };

  isSidebarVisible = false;
  smallTabView: boolean = false;
  showSidebarButton: boolean = false;
  dragging: boolean = false;
  userName: string = 'Benutzername';
  userEmail: string = '';
  userRole: any;
  smallScreen = false;
  currentUrl: string = '';
  eventListHeight = 800;
  eventSearchInput: any = '';
  advancedSearchPlaceholder: string = '';
  userIconUrl: any;
  errorCount: number = 0;
  notValidCount: number = 0;
  totalEvents: number = 0;
  eventsWithErrors: any;

  lastErrorCheck?: string;

  private isResizing = false;
  private startY = 0;
  private startHeight = 0;
  private closeTimeout: any;
  private destroy$ = new Subject<void>();

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.ctrlKey && event.key.toLowerCase() === 's') {
      event.preventDefault(); // Browser-Speichern verhindern
    
      this.searchInput.nativeElement.focus();
    }
  }

  get isAdminCalendar(): boolean {
    return this.router.url.includes('/admin-calendar');
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.lastErrorCheck = new Date().toLocaleString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });


    //Datum abonnieren
    this.dateChangeService.selectedDate$
      .pipe(
        takeUntil(this.destroy$),
        filter((date): date is Date => !!date)
      )
      .subscribe(date => {
        this.selectedDate = date;
        this.selectedDateInput = date;
        this.fetchEventsWithErrors(date);
      });

    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.currentUrl = event.url;
        this.handleUrlChange();
      });

    this.setDateFromUrl();
    this.handleUrlChange();
    this.checkForCalcTraveltime();
    this.screenService.checkScreenWidth();
    this.getUserName();
    this.getUserEmail();
    this.getUserPermission();
    this.getUserRole();
    this.getCurrentUrlPath();
    this.checkWindowSize();
    this.loadUserIcon();
    this.socketOnErrorCountUpdate()

    this.placeholderService.placeholder$.subscribe(value => {
      this.advancedSearchPlaceholder = value;
      this.setInputValue(this.advancedSearchPlaceholder);
    });
  }


  setDateFromUrl(){
    const dateParam = this.route.snapshot.paramMap.get('date');
        
    if (dateParam) {
      const date = new Date(dateParam);
    
      if (!isNaN(date.getTime())) {
        this.dateChangeService.setSelectedDate(date);
      }
    }
  }


  async socketOnErrorCountUpdate() {
    this.socketService.onErrorCountUpdate().subscribe((data) => {

      if (!data) return;

      const payload = Array.isArray(data) ? data[1] : data;

      this.eventsWithErrors = payload.result

      console.log('Fehlerereignis empfangen, aktualisierte Events mit Fehlern:', this.eventsWithErrors);
      this.lastErrorCheck = new Date().toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });

    });
  }


  async fetchEventsWithErrors(startOfDay: any) {
    const formattedDate = new Date(startOfDay).toISOString().split('T')[0];  
    this.eventsWithErrors = await firstValueFrom(this.getEventService.fetchEventsWithErrors(formattedDate));
    this.cdr.detectChanges();
  }


  get totalFetched(): number {
    return this.eventsWithErrors?.meta?.totalFetched ?? 0;
  }


  get totalWithErrors(): number {
    return this.eventsWithErrors?.meta?.totalWithErrors ?? 0;
  }


  get totalNotChecked(): number {
    return this.eventsWithErrors?.meta?.totalNotchecked ?? 0;
  }


  get totalAddressMissing(): number {
    return this.eventsWithErrors?.eventsByError?.ADDRESS_MISSING?.length ?? 0;
  }


  get totalAddressInvalidFormat(): number {
    return this.eventsWithErrors?.eventsByError?.ADDRESS_INVALID_FORMAT?.length ?? 0;
  }


  get totalOnlineEvents(): number {
    return this.eventsWithErrors?.meta.totalEventsOnline ?? 0;
  }


  get totalOnlineLinkMissing(): number {
    return this.eventsWithErrors?.eventsByError?.ONLINE_LINK_MISSING?.length ?? 0;
  }


  get totalOnlineLinkInvalid(): number {
    return this.eventsWithErrors?.eventsByError?.ONLINE_LINK_INVALID?.length ?? 0;
  }


  get totalErrorTicketNo(): number {
    return this.eventsWithErrors?.eventsByError?.ERROR_TICKETNO?.length ?? 0;
  }


  get totalErrorVbMaterialMissing(): number {
    return this.eventsWithErrors?.eventsByError?.ERROR_VBMATERIAL_MISSING?.length ?? 0;
  }


  get totalErrorVbMaterialLinkInvalid(): number {
    return this.eventsWithErrors?.eventsByError?.ERROR_VBMATERIAL_LINK_INVALID?.length ?? 0;
  }


  get totalErrorInterpreter(): number {
    return this.eventsWithErrors?.eventsByError?.ERROR_INTERPRETER?.length ?? 0;
  }


  get totalErrorStatus(): number {
    return this.eventsWithErrors?.eventsByError?.ERROR_STATUS?.length ?? 0;
  }


  get totalErrorBacklog(): number {
    return this.eventsWithErrors?.eventsByError?.ERROR_BACKLOG?.length ?? 0;
  }


  get allErrors(): number {
    return (this.eventsWithErrors?.errorCounts?.ADDRESS_INVALID_FORMAT ?? 0)
      + (this.eventsWithErrors?.errorCounts?.ADDRESS_MISSING ?? 0)
      + (this.eventsWithErrors?.errorCounts?.ERROR_INTERPRETER ?? 0)
      + (this.eventsWithErrors?.errorCounts?.ERROR_TICKETNO ?? 0)
      + (this.eventsWithErrors?.errorCounts?.ONLINE_LINK_MISSING ?? 0)
      + (this.eventsWithErrors?.errorCounts?.ERROR_BACKLOG ?? 0)
      + (this.eventsWithErrors?.errorCounts?.ERROR_STATUS ?? 0)
      + (this.eventsWithErrors?.errorCounts?.ERROR_VBMATERIAL_MISSING ?? 0)
      + (this.eventsWithErrors?.errorCounts?.ONLINE_LINK_INVALID ?? 0) 
      + (this.eventsWithErrors?.meta?.totalNotchecked ?? 0);
  }


  getEventsToFilter(filter: string){
    this.resetErrorFilter();
    let filterLocation;
 
    switch (filter) {
      case 'eventsNotChecked':
        this.filterName = 'Nicht geprüft';
        filterLocation = this.eventsWithErrors?.eventsNotChecked;
        break;
      case 'errorStatus':
        this.filterName = 'Nicht gebucht';
        filterLocation = this.eventsWithErrors?.eventsByError.ERROR_STATUS;
        break;
      case 'errorAddressMissing':
        this.filterName = 'Adresse fehlt';
        filterLocation = this.eventsWithErrors?.eventsByError.ADDRESS_MISSING;
        break;
      case 'errorAddressInvalid':
        this.filterName = 'Adressformat';
        filterLocation = this.eventsWithErrors?.eventsByError.ADDRESS_INVALID_FORMAT;
        break;
      case 'errorOnlineLinkMissing':
        this.filterName = 'Link fehlt';
        filterLocation = this.eventsWithErrors?.eventsByError.ONLINE_LINK_MISSING;
        break;
      case 'errorOnlineLinkInvalid':
        this.filterName = 'Linkformat';
        filterLocation = this.eventsWithErrors?.eventsByError.ONLINE_LINK_INVALID;
        break;
      case 'errorTicketMissing':
        this.filterName = 'Ticketnummer fehlt';
        filterLocation = this.eventsWithErrors?.eventsByError.ERROR_TICKETNO;
        break;
      case 'errorVbMissing':
        this.filterName = 'VBM fehlt';
        filterLocation = this.eventsWithErrors?.eventsByError.ERROR_VBMATERIAL_MISSING;
        break;
      case 'errorInterpreter':
        this.filterName = 'Dolmetscher fehlen';
        filterLocation = this.eventsWithErrors?.eventsByError.ERROR_INTERPRETER;
        break;
    }

    const filterIds = filterLocation.map((event: { id: any; }) => event.id);
    if(filterIds.length > 0){
      this.errorFilterActive = true;
      this.eventFilterError.emit({filterIds, filterName: this.filterName});
    }
  }

  
  resetErrorFilter(){
    this.filterName = '';
    this.errorFilterActive = false;
    this.resetFilterError.emit();
  }


  handleUrlChange() {
    this.setInputValue(this.advancedSearchPlaceholder || '');
  }


  setInputValue(value: any) {
    if (value === null || value === undefined || value === '/' || value === '') {
      value = '';
    }

    if (this.currentUrl.includes('search-event-view')) {
        this.eventSearchInput = value ? `(titel=${value})` : '';
    }else if (this.currentUrl.includes('search-advanced-event-view')) {
        this.eventSearchInput = value;
    }else {
        this.eventSearchInput = '';
    }
  }


  loadUserIcon() {
    this.userIconUrl = './../../../../assets/icons/user.png';

    this.fetchUserService.loadUserIcon().subscribe(
      (blob: Blob | null) => {
        if (blob && blob.size > 0) {
          this.userIconUrl = URL.createObjectURL(blob);
          // console.log('Benutzerbild erfolgreich geladen:', this.userIconUrl);
        } else {
          console.warn('Kein gültiges Benutzerbild vorhanden.');
          this.userIconUrl = './../../../../assets/img/app-icons/user.png';
        }
      },
      (error: any) => {
        console.error('Fehler beim Laden des Benutzerbildes:', error);
        this.userIconUrl = './../../../../assets/img/app-icons/user.png';
      }
    );
  }


  @HostListener('window:resize', [])
  onResize() {
    this.checkWindowSize();
  }


  private checkWindowSize() {
    this.showSidebarButton = window.innerWidth <= 800;
    this.smallTabView = window.innerWidth <= 2540;
  }


  checkForCalcTraveltime() {
    const calcTrav = localStorage.getItem('calcTraveltime');
    if (calcTrav === null) {
      localStorage.setItem('calcTraveltime', 'true');
    } else {
      this.traveltimeService.calcTraveltimeGlobal = this.toBoolean(calcTrav);
    }
  }


  set(event: any) {
    const calcTrav = event;
    localStorage.setItem('calcTraveltime', calcTrav);
    this.traveltimeService.calcTraveltimeGlobal = event;
  }


  toBoolean(value: any): boolean {
    return value === true || value === "true";
  }


  getUserName() {
    const firstname = localStorage.getItem('firstName');
    const lastname = localStorage.getItem('lastName');
    this.userName = firstname + ' ' + lastname;
  }


  getUserEmail() {
    const userJson = localStorage.getItem('authUser');

    if (userJson) {
      const authUser = JSON.parse(userJson);
      this.userEmail = authUser.user?.email;
    }
  }


  navigateTo(route: string) {
    window.location.href = route;
    localStorage.removeItem('selectedTeamId');
  }


  reloadPage() {
    window.location.href = '/admin-calendar'
  }


  getUserPermission() {
    const authUserString = localStorage.getItem('authUser');

    if (!authUserString) {
      this.UserPermission = null;
      return;
    }

    try {
      const authUser = JSON.parse(authUserString);

      // permissions aus beiden möglichen Strukturen holen
      const rawPermissions =
        authUser.user?.permissions ||
        authUser.permissions ||
        [];

      // Falls String -> parsen
      const permissions =
        typeof rawPermissions === 'string'
          ? JSON.parse(rawPermissions)
          : rawPermissions;

      const calendarPermission = permissions.find(
        (p: any) => p.app_name === 'CALENDAR-ADMIN'
      );

      this.UserPermission = calendarPermission?.permission_level || null;

    } catch (error) {
      console.error('Fehler beim Parsen:', error);
      this.UserPermission = null;
    }
  }


  getUserRole() {

    const authUserString = localStorage.getItem('authUser');

    if (!authUserString) {
      this.UserRole = null;
      return
    }

    try {
      const authUser = JSON.parse(authUserString);

      // unterstützt beide Strukturen
      const role =
        authUser.user?.role ||
        authUser.role ||
        null;

      this.UserRole = role;

    } catch (error) {
      console.error('Fehler beim Parsen:', error);
      this.UserRole = null;
    }
  }


  getCurrentUrlPath() {
    this.currentUrl = this.router.url;
  }


  openEventFilter() {
    this.popupAnchor = this.eventAnchorElm.nativeElement;
    this.eventFilterPopup.openEventFilter(this.popupAnchor);
  }


  onFilteredEventChange(filtered: any[] | null | undefined) {
    if(this.currentUrl.includes('admin-calendar')) {
      this.listEvents = Array.isArray(filtered) ? filtered : [];
      this.displayResults = true;
    }
  }


  onInput(ev: Event): void {
    const searchText = (ev.target as HTMLInputElement).value.trim();

    if (this.timer) clearTimeout(this.timer);

    if (searchText === '') {
      this.displayResults = false;
      this.listEvents = [];
      this.originalEvents = [];
      this.setLoading.emit(false);
      this.toggleOverlay.emit(false);
      return;
    }

    if (searchText.length > 3 && this.currentUrl.includes('admin-calendar')) {
      this.setLoading.emit(true);
      this.toggleOverlay.emit(true);

      this.timer = setTimeout(() => {
          this.getEventService.fetchSearchEvents({ search: searchText }).subscribe(response => {
            if (response && response.length > 0) {
              this.originalEvents = response;
              this.listEvents = response;
              this.eventListHeight = 800;
            } else {
              this.listEvents = [];
              this.originalEvents = [];
              this.eventListHeight = 200;
            }
          });
           this.displayResults = true;
           this.setLoading.emit(false);
      }, 200);
    }
  }


  onEventClick(args: any): void {
    if (this.router.url.startsWith('/admin-calendar')) {
      this.eventClicked.emit(args);
      this.setDatePickerAfterEventClick(args);
      this.calendarEventService.emitEventClicked(args);
      this.closeEventList();
    } else if (this.router.url.startsWith('/search-event-view')) {
      window.location.href = 'admin-calendar/' + args.event.id;
    }
  }


  onEventWithErrorClick(args: any): void {
    this.eventClicked.emit(args.event);
    this.calendarEventService.emitEventClicked(args);
  }


  closeEventList(emitEvent = true) {
    this.listEvents = [];
    this.originalEvents = [];
    this.eventSearchInput = '';
    this.displayResults = false;
    if (emitEvent) {
      this.toggleOverlay.emit(false);
    }
  }


  setDatePickerAfterEventClick(args: any) {
    const startOfDay = new Date(args.event.start);
    startOfDay.setHours(0, 0, 0, 0);
    this.selectedDate = startOfDay;
  }


  startResize(event: MouseEvent): void {
    event.preventDefault();
    document.body.classList.add('no-select');
    this.isResizing = true;
    this.startY = event.clientY;
    this.startHeight = this.eventListHeight;

    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.stopResize);
  }


  onMouseMove = (event: MouseEvent): void => {
    if (!this.isResizing) return;
    const diff = event.clientY - this.startY;
    this.eventListHeight = Math.min(900, Math.max(100, this.startHeight + diff));
  };


  stopResize = (): void => {
    this.isResizing = false;
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.stopResize);
  };


  cancelClose() {
    clearTimeout(this.closeTimeout);
  }


  openEventSearch() {

    if (this.currentUrl.includes('admin-calendar')) {

      this.router.navigate(['search-event-view', this.eventSearchInput]);
      this.closeEventList();

    } else if (this.currentUrl.includes('search-event-view')) {

      this.router.navigate(['search-advanced-event-view', this.eventSearchInput]);
      this.closeEventList();

    } else if (this.currentUrl.includes('search-advanced-event-view')) {

      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';

      this.router.navigate(['search-advanced-event-view', this.eventSearchInput]);
      this.closeEventList();
    }
  }


  get searchPlaceholder(): string {
    if (this.currentUrl.includes('admin-calendar')) {
      return 'Mindestens 4 Zeichen eingeben…';
    } else if (this.currentUrl.includes('search-event-view')) {
      return `(title=${this.advancedSearchPlaceholder} AND id=2) OR (location=Berlin)`;
    } else if (this.currentUrl.includes('search-advanced-event-view')) {
      return `${this.advancedSearchPlaceholder}`;
    }
    return 'Suche...';
  }


  @ViewChild('popup', { static: false }) popup!: MbscPopup;
    // popupAnchor: HTMLElement | undefined;

    popupOptions: MbscPopupOptions = {
    display: 'anchored',
    buttons: ['close'],
    headerText: 'Erweiterte Suche',
    height: 'auto',    
    maxHeight: '100%',  
    scrollLock: false, 
    showOverlay: true  
  };


  openPopup(ev: any): void {
    this.popupAnchor = ev.currentTarget;
    this.popup.open();
  }


  onClose(): void {
    // Your custom event handler goes here
  }


  onDestroy(): void {
    // Your custom event handler goes here
  }


  onInit(): void {
    // Logic running on component init
  }


  onOpen(): void {
    // Your custom event handler goes here
  }


  onPosition(): void {
    // Logic for component positioning
  }


  toggleSidebar() {
    this.isSidebarVisible = !this.isSidebarVisible;  
  }


  onWrapperClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (target.classList.contains('resizable-event-wrapper')) {
      this.closeEventList();
    }
  }
}